<template>
    <div class="body"> 
    <div class="container">
      
      <div class="bigTitleOne" v-scroll-animate="'slide-itemgk'">
       

         <div class="chineseA">
          <a href="/news" style="color: #333333;">新闻动态</a> 
        </div>
        <div class="englishA bounce-element1"> 
          <a href="/news" class="pulse-text" >News</a>
        </div>
      </div>
      
      <!-- <div class="bigTitleOne wow fadeInDown animated" style="visibility: visible; animation-name: fadeInDown;">新闻动态</div> -->
      <div class="firstCon">
        <!-- <div class="oneCon" v-scroll-animate="'fly-in-left5'"> -->
          <div class="oneCon"  v-scroll-animate="'duijiaoAnimate'">
            <el-carousel  :interval="3000" :autoplay="true" hover-stop class="first-left Hcssy" height="24rem" >
                <el-carousel-item v-for="(item, index) in imgList" :key="index">
                  <div class="carousel-item">
                    <a @click="navigateToDetail(item.articleId)"><img :src="urlBase+item.image" alt="" :style="{ width: 'auto', height: '90%', objectFit: 'cover' }" /></a>
                        <div class="tips_newsfont">
                        <p>{{ item.title }}</p>
                        </div>
                      </div>
                </el-carousel-item>
            </el-carousel>

        </div>
        <!-- <div class="twoCon" v-scroll-animate="'fly-in-right5'"> -->
          <div class="twoCon"  v-scroll-animate="'duijiaoAnimate1'">
            <div class="content-news">
                <div v-for="(item, index) in newsList.slice(0,9)" :key="index" class="list-news"  @click="navigateToDetail(item.articleId)">
                        <!-- <h3 class="news-title">{{ item.title }}</h3> -->
                        <!-- <div class="news-detail" v-html="item.articleData.content"></div> -->
                        <!-- <p class="news-time">{{ item.publishDate}}</p> -->
                    <!-- <hr class="custom-hr"> -->
                     <div class="newCss0" > 
                      <span class="dotSpan" style="float: left;" v-if="30>item.title.length"> {{ item.title }}</span>
                      <span class="dotSpan" style="float: left;" v-else> {{ item.title.substring(0,29) }}...  </span>
                      <span class="timeSpan" style="float: right;"> {{ item.createDate.substring(0,10)}}</span>
                      
                     </div>
                </div>
                </div>
        </div>
    </div>
    </div>
</div>
  </template>
  
  <script>
    import API from '@/api/index'
  
  export default {
    data() {
      return {
        imgList: [],
        newsList:[],
        urlBase: process.env.VUE_APP_BASE_API
      }
    },
    mounted() {
       
       this.getFirstRotation()    // 左侧轮播图
       this.getFirstNews()    // 左侧轮播图
     
     },
    methods: {
      // 获取左侧轮播图
      async getFirstRotation() {
        try {
          let paramsObj={
            catId:'3d203d299bcf4da5952ce9495dcdec03'
        }
          const res = await API.getNewsInfo(paramsObj)
          
           this.imgList=res.data.articleLinkList
          } catch (error) {
          }
        },
          // 获取右侧新闻
      async getFirstNews() {
        try {
          let paramsObj={
            catId:'1ae1ef95710e4feeb1d00463dcf26168',
            pageSize:7
        }
        
          const res = await API.getNewsInfo(paramsObj)
           this.newsList=res.data.articleLinkList
          } catch (error) {
          }
        },
        navigateToDetail(articleId){
      // const encodedTitle = encodeURIComponent(currentPanel.explains)
     
          // this.$router.push({
          //   path: '/newsDetailHome',
          //   query: {                     
          //     artId: articleId 
          //   }
          // })
          window.open('/newsDetailHome?artId='+articleId, '_blank');
        }
      }
  }
  </script>
  
  <style lang="scss" scoped>
  .body{
    background-color: #F4F4F4 ;

  }
  .container {
    width: 90%;
    margin: 0 auto;
    // padding-top: 7vh;
    position: relative;
    transition: all .4s ease;
    }
    .bigTitleOne {
    
    line-height: 6rem;
    color: #333;
    text-align: center;
    @media screen and (max-width: 768px) {
      font-size: 1.2rem;
    }
   
    // margin-bottom: 3vh;
    }
    
    .firstCon{
      width:100%;
      height:100%;
      display: flex;
      @media screen and (max-width: 768px) {
        flex-direction: column;;
      }
    }
    .oneCon{
      width:50%;
      flex: 50%;
      @media screen and (max-width: 768px) {
          width:100%;
      }
     
    }
    .twoCon{
      margin-left: 2%;
      width:48%;
      display: inline-block; 
      box-shadow: 0 1px 12px rgba(3, 3, 3, 0.16);
      // @media (min-width: 0px) and (max-width: 991px) {
      //   width:100%;
      //   margin-left: 0;
      //   display: block; 
      //   margin-top:2rem
      // } 
      @media screen and (max-width: 768px) {
          width:100%;
      }
    }
    .el-carousel-item{
        // width:100%;
        height: 100%;
    }
    .carousel-item {
      display: flex; /* 使用Flex布局 */
      height: 100%; /* 确保项目高度为100% */
    }
  .tips_newsfont {
    width:100%;
    position: absolute;
    bottom: 0;
    // line-height: 40px;
    // left: 300px;
    z-index: 5;
    color: #fff;
    @media screen and (max-width: 768px) {
    }
    background: rgba(24, 90, 171, 0.6);
  }
  .tips_newsfont p{
    // padding:2vh 1vh;
    padding-left: 10px;
    font-size: 1rem;
    line-height: 40PX;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    margin-right:9vh
  }
  .pic_item{
    width:100%;
      height: 100%;
      object-fit: cover;
  }
  @keyframes slideInFromLeft {
  0% {
    transform: translateX(-100%); /* 元素从左边开始，超出可视区域 */
    opacity: 0; /* 初始时不可见 */
  }
  100% {
    transform: translateX(0); /* 元素到达正常位置 */
    opacity: 1; /* 完全可见 */
  }
}
 
.first-left {
  // animation: slideInFromLeft 1s ease-out forwards; /* 应用动画，持续1秒，缓动函数为ease-out，结束后保持最终状态 */
}
  /*指示器*/
.first-left .el-carousel__indicators {
left: unset;
  transform: unset;
  right: 2%;
  bottom:2.4%
}
:deep(.el-carousel__indicators--horizontal){
    left: 90%;
    line-height: 28PX;
}
 /*指示器按钮*/ 
 .first-left .el-carousel__button {
   width: 1vh;
  height: 1vh;
  border: none;
  border-radius: 50%;
  background-color: #fff;
}
/*指示器激活按钮*/
.first-left .is-active .el-carousel__button {
  background: #015293;
}
 
.first-left .el-carousel__container {
  height: 100%;
}
@keyframes slideInFromRight {
  0% {
    transform: translateX(100%); /* 元素从左边开始，超出可视区域 */
    opacity: 0; /* 初始时不可见 */
  }
  100% {
    transform: translateX(0); /* 元素到达正常位置 */
    opacity: 1; /* 完全可见 */
  }
}
 
.content-news {
  // animation: slideInFromRight 1s ease-out forwards; /* 应用动画，持续1秒，缓动函数为ease-out，结束后保持最终状态 */
}
  .content-news{
    height: 24rem;
    padding-top: 0.8rem;
    // border-radius: 1rem;
    overflow-y: hidden;
    background-color: #fff;
    @media screen and (max-width: 768px) {
      // height:50vh;
    }

  }
  .list-news{
    // height:16vh;
    // padding:1rem 1rem 0.6rem 2rem;
    height:2.5rem;
    padding-left: 1rem;
    padding-right: 1rem;
    line-height:2.5rem;
    // padding-bottom: 0;
    overflow: hidden; /* 关键属性：隐藏超出部分 */
    // border-bottom: 1px solid #eee;
    color: #333333;

  }
  .list-news:hover {
    background-color: #015293;
   
    *{
      color: white; /* 注意：背景颜色通常不应用于链接，除非你有特定的背景容器 */
    }
  }
  // .list-news:hover div{
  //   background-color: #015293!important;
  //   color: white; /* 注意：背景颜色通常不应用于链接，除非你有特定的背景容器 */
  // }
  .list-news:last-child{
    border-bottom:none;

  }
  .news-title{
    font-size: 1.1rem;
    // margin-bottom: 1rem;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    @media screen and (max-width: 768px) {
      font-size: 1rem;
    }
  }
  .news-detail{
    height: 4.4vh; /* 假设行高大约是1.2em */
    overflow: hidden;
    // padding-top:5px;
    background-color: none!important;

  }
  :v-deep .news-detail p{
    background-color:transparent !important;
    font-size: 1.2vw!important;
    line-height:1.2vw!important;
    // margin-bottom: 1vh;
     
  }
  :v-deep .news-detail p span{
    all:unset;
    font-size: 1.2vw!important;
    line-height: 1.2vw!important;
    background-color: none!important;
    
  }
  .news-detail p span{
    @media screen and (max-width: 768px) {
      font-size: 1rem !important;
    }
  }
  

  :v-deep .news-detail p span span{
    all:unset;
    font-size: 1.2vh!important;
    line-height:1.2vw!important;
    background-color: none!important;
    color:red;
   
  }
 .news-detail p{
    background-color:transparent !important;
  }
  :v-deep  .news-detail p{
    font-size: 1.2vh!important;
    line-height:1.2vw!important;
   
  }



  .news-time{
    padding-top:1vh;
    font-size: 0.9rem;
    white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  }
  </style>
    <style lang="scss" scoped> 
    .container {
      min-height: 70vh !important;
      padding-top: 5vh !important;
      position: relative;
      transition: all .4s ease;
      @media screen and (max-width: 768px) {
          padding-top: 0vh !important;
          min-height: 50vh !important;
        }
    }
    .Hcssy{
      height: 24rem;
      overflow: hidden;
      @media screen and (max-width: 768px) {
        height: 26vh;
      }
    }
    .newCss0{
      clear: both;
      font-size: 2.5vh;
      cursor: pointer;
      @media screen and (max-width: 768px) {
        font-size: 2vh;
      }
    }
    .dotSpan::before {
      content: "";
      display: inline-block;
      width: 8px;
      height: 8px;
      background-color: #3498db;
      border-radius: 50%;
    }
    .timeSpan{
      font-size: 0.9rem;
      color: #999999;
    }
   


    </style>